import { BsTools } from "react-icons/bs";
import { MdOutlineDesignServices } from "react-icons/md";
import { MdSettings } from "react-icons/md";
import ShowAnyThing from "./Components/buttonUses";
import breaklineLeft from '../../pic/brakeLine.png'
import breaklineRight from '../../pic/brakeLine2.png'

export default function AboutMe(){
    return(
        <div className="flex flex-col mb-24 text-[#1F2937]" id="about">
            <div className="pt-40">
                {/* About Me Main */}
                <ShowAnyThing  name={"ABOUT ME"}/>
                {/* About Talkes */}

                <div className="container lg:text-start md:text-start text-justify mx-auto mt-14 lg:px-20 md:px-20 px-5 lg:w-[963px] lg:h-[190px] md:[963px] md:h-[190px] w-420 h-500">
                        <p className="py-5 text-xl"> I'm a passionate fresh-graduate who's seeking to become a professional engineer, Ihave the ambition to be the backbone of the company in the development process.</p>
                        <p className="py-5 text-xl">I'm open to both job and internship opportunities that will allow me to apply myskills, gain practical experience, and develop my expertise in a professional environment.</p>
                </div>
            </div>
            {/* More Button */}
            <div className="container mx-auto w-full text-center mt-28">
                <button className="border-r-[4px] border-l-[4px] px-20 border-black text-xl">MORE</button>
            </div>
            {/* Design -- Maintain -- Develop */}
            <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-flow-row  container mx-auto gap-8 mt-32 xlg:px-6 md:px-10 px-6 lg:text-start md:text-start text-justify">
                <div className="relative">
                    <div className="lg:text-6xl md:text-5xl text-5xl lg:top-[-30px] lg:left-[-35px] md:top-[-30px] md:left-[-30px] top-[-24px] left-[-15px] opacity-10 absolute">
                        <MdOutlineDesignServices />
                    </div>
                    <h1 className="lg:text-4xl md:text-4xl text-2xl font-semibold">DESIGN</h1>
                    <p>I can design the website based on your needs and suggestions. I can also create it from scratch by consulting with you during work.</p>
                </div>
                <div className="relative">
                    <div className="lg:text-6xl md:text-5xl text-5xl lg:top-[-30px] lg:left-[-35px] md:top-[-30px] md:left-[-30px] top-[-24px] left-[-15px] opacity-10 absolute">
                        <BsTools />
                    </div>
                    <h1 className="lg:text-4xl md:text-4xl text-2xl font-semibold">DEVELOPMENT</h1>
                    <p>Based on a project created by me or another one, sent by you, I can program the website to be fully functional and responsive.</p>
                </div>
            </div>
            <div className="flex flex-row justify-center lg:mt-20 md:mt-20 mt-14 px-6 lg:text-start md:text-start text-justify">
                <div className="relative lg:w-1/2 md:w-3/4 w-full">
                    <div className="lg:text-6xl md:text-5xl text-5xl lg:top-[-30px] lg:left-[-35px] md:top-[-25px] md:left-[-30px] top-[-24px] left-[-15px] opacity-10 absolute">
                        <MdSettings />
                    </div>
                    <h1 className="lg:text-4xl md:text-4xl text-2xl font-semibold">MAINTENANCE</h1>
                    <p>In case of any problems or the need for changes, I can introduce new functionalities and solutions.</p>
                </div>
            </div>
            <div className="flex flex-row gap-2 lg:mt-24 md:mt-20 mt-14 w-full justify-center">
                <img src={breaklineLeft}   className="lg:w-1/6 md:w-1/6 w-1/3" alt="" />
                <img src={breaklineRight}  className="lg:w-1/6 md:w-1/6 w-1/3" alt="" />
            </div>
        </div>
    )
}